import React from 'react';
import styled from "styled-components";
import DateFlicker, { DateScale } from '@shared/ui/molecules/DateFlicker';
import { tablet } from '@shared/ui/atoms/MediaQueries';
import moment, { Moment } from "moment";
import { addOrReplaceQueryParam } from '@shared/utils/UrlUtils';
import { useSelector } from "react-redux";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { PageTitle } from '@shared/ui/atoms/PageTitle';
import { selectConfig } from '@shared/store/config.duck';
import { toAirBnbDate } from '@shared/utils/DateUtils';
import { selectHasHolidayLoadError, selectHolidayUserInfo } from '@features/holidays/store/holidays-v2.duck';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { selectCurrentUser } from '@shared/store/auth.duck';

export function UsersAnnualLeaveHeader(props: Props) {
  const calendarDate = useSelector(selectCalendarDate);
  const config = useSelector(selectConfig);
  const hasLoadError = useSelector(selectHasHolidayLoadError);
  const currentUser = useSelector(selectCurrentUser);
  const holidayUser = useSelector(selectHolidayUserInfo);
  const onDateChange = (date: Moment) => {
    addOrReplaceQueryParam('year', `${date.year()}`);
  }

  const isViewingOtherUser = !!holidayUser.userId && holidayUser.userId !== currentUser?.id;
  const otherUsersTitle = isViewingOtherUser && !!holidayUser.firstName && !!holidayUser.lastName
    ? `${holidayUser.firstName} ${holidayUser.lastName}'s Leave`
    : undefined;

  return (
    <Container>
      {hasLoadError
        ? <GoBackButton />
        : <PageTitle text={'holidays.holidays'} overrideText={otherUsersTitle} style={{marginTop: 0}} />}
      <DateFlicker dateScale={DateScale.Year}
                   updateGlobalDate={true}
                   onChange={onDateChange}
                   dateLabelOverride={toAirBnbDate(config.getHolidayYearStartDate(calendarDate), config.getHolidayYearEndDate(calendarDate) || moment())}
                   date={config.getHolidayYearStartDate(calendarDate)}
                   showDateRange={true}
                   fontWeight={600} />
    </Container>
  )
}

interface Props {
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  box-shadow: 0 10px 15px -20px #000000;
  max-width: 100%;
  @media (${tablet}) {
    flex-direction: row;
    padding-bottom: 12px;
  }
`
